import { useState, useMemo, useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { FiBell, FiLogOut } from "react-icons/fi";
import { useHeader } from "@context/HeaderTitleContext";
import useAuth from "@/hooks/auth/useAuth";
import Cookies from "js-cookie";

export default function Header() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement | null>(null);

  const { title } = useHeader();

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <header className="bg-white rounded-xl shadow px-6 py-4 flex items-center justify-between">
      <h1 className="text-2xl font-bold text-gray-800">{title}</h1>

      <div className="flex items-center gap-4 relative" ref={dropdownRef}>
        <button className="p-2 rounded-2xl border hover:bg-gray-100">
          <FiBell className="text-xl text-gray-500" />
        </button>

        <button onClick={() => setDropdownOpen(!dropdownOpen)}>
          <svg
            viewBox="0 0 64 64"
            xmlns="http://www.w3.org/2000/svg"
            className="w-10 h-10"
          >
            {/* Light blue background */}
            <circle cx="32" cy="32" r="30" fill="#BFDBFE" />

            {/* Face */}
            <circle cx="32" cy="24" r="10" fill="#93C5FD" />

            {/* Shoulders / body */}
            <path
              d="M16 52c0-8.84 7.16-16 16-16s16 7.16 16 16"
              fill="#60A5FA"
            />

            {/* Eyes */}
            <circle cx="28" cy="22" r="2" fill="#1E3A8A" />
            <circle cx="36" cy="22" r="2" fill="#1E3A8A" />

            {/* Smile */}
            <path
              d="M28 28c1.5 2 6.5 2 8 0"
              stroke="#1E3A8A"
              strokeWidth="1.5"
              fill="none"
              strokeLinecap="round"
            />
          </svg>
        </button>

        {dropdownOpen && <UserDropdown />}
      </div>
    </header>
  );
}

function UserDropdown() {
  let { userData }: any = useAuth();

  const HandleLogout = (e: any) => {
    e.preventDefault();

    Cookies.remove("token");
    Cookies.remove("user_id");

    window.location.href = "https://sso.edkamm.com/login";
  };
  return (
    <div className="absolute right-0 top-16 w-80 bg-white rounded-xl border shadow-xl z-50">
      <div className="p-4 border-b">
        <p className="text-sm text-gray-600 font-medium">Account</p>
        <div className="mt-2 flex items-center gap-3">
          <svg
            viewBox="0 0 64 64"
            xmlns="http://www.w3.org/2000/svg"
            className="w-10 h-10"
          >
            {/* Light blue background */}
            <circle cx="32" cy="32" r="30" fill="#BFDBFE" />

            {/* Face */}
            <circle cx="32" cy="24" r="10" fill="#93C5FD" />

            {/* Shoulders / body */}
            <path
              d="M16 52c0-8.84 7.16-16 16-16s16 7.16 16 16"
              fill="#60A5FA"
            />

            {/* Eyes */}
            <circle cx="28" cy="22" r="2" fill="#1E3A8A" />
            <circle cx="36" cy="22" r="2" fill="#1E3A8A" />

            {/* Smile */}
            <path
              d="M28 28c1.5 2 6.5 2 8 0"
              stroke="#1E3A8A"
              strokeWidth="1.5"
              fill="none"
              strokeLinecap="round"
            />
          </svg>
          <div>
            <p className="text-base font-semibold">
              {
                //@ts-ignore
                `${userData?.data?.first_name ?? ""} ${
                  //@ts-ignore
                  userData?.data?.last_name ?? ""
                }` || "-"
              }
            </p>
            <p className="text-sm text-gray-500">
              {
                //@ts-ignore
                userData?.data.position_name ?? "-"
              }
            </p>
          </div>
        </div>
      </div>

      <div className="p-4 space-y-2 text-sm text-gray-700">
        <InfoRow
          label="ID"
          value={
            //@ts-ignore
            userData?.data.employee_id ?? "-"
          }
        />
        {/* <InfoRow label="Name" value="Saw Yan Naing" />
        <InfoRow label="Position" value="Assistant Manager" /> */}
        {/* <InfoRow label="Team" value="UI/UX Team" /> */}
        <InfoRow
          label="Department"
          value={
            //@ts-ignore
            userData?.data.dept_name ?? "-"
          }
        />
      </div>

      <div className="border-t p-4">
        <button
          className="flex items-center gap-2 text-red-500 hover:underline text-sm"
          onClick={HandleLogout}
        >
          <FiLogOut />
          Logout
        </button>
      </div>
    </div>
  );
}

function InfoRow({ label, value }: { label: string; value: string }) {
  return (
    <div className="flex justify-between">
      <span className="text-gray-500">{label} :</span>
      <span className="font-medium">{value}</span>
    </div>
  );
}
